module.exports = __webpack_public_path__ + "img/tn-timeline-main-4.662579e1.jpg";